






















import Vue, { PropOptions } from 'vue';

interface Props {
  lesson: PropOptions;
}

export default Vue.extend({
  name: 'LessonCard',
  components: {},
  props: {
    lesson: {
      type: Object as () => LessonResponse,
      default: null,
    },
    active: {
      type: Boolean,
      default: null,
    },
    showDuplicate: {
      type: Boolean,
      default: true,
    },
  } as Props,
  methods: {
    async duplicate(): Promise<void> {
      this.$emit('duplicate', this.lesson);
    },
    async remove(): Promise<void> {
      this.$emit('remove', this.lesson);
    },
  },
});
